import React from "react";
import LoginForm from "../component/Register/LoginForm";

const LoginPage = () => {


  return (
    <section className="text-gray-900 transition-colors bg-bg-light-primary dark:bg-bg-dark-primary dark:text-gray-100">
      <div className="">
        <LoginForm />
      </div>
    </section>
  );
};

export default LoginPage;
